<template>
	<v-container fluid class="email-view py-12 bg-f5f">
		<v-layout align-center>
			<v-breadcrumbs :items="breadcrumbs" class="pa-0">
				<template v-slot:item="{ item }">
					<v-breadcrumbs-item
						:href="item.href"
						:disabled="item.disabled"
						:class="{ 'font-weight-bold': item.disabled }"
						class=">*:base-text"
					>
						{{ item.text }}
					</v-breadcrumbs-item>
				</template>
			</v-breadcrumbs>
			<v-icon> mdi-information-outline </v-icon>

			<base-text small color="a5a" class="ml-12"> PO Number</base-text>
			<v-chip outlined class="ml-4 border-068 bg-f5f">
				<base-text color="068" class="underline">737007</base-text>
			</v-chip>

			<base-text small color="a5a" class="ml-8">Status</base-text>
			<v-chip outlined class="ml-4 border-f57 bg-ffe">
				<base-text color="f57">Approved</base-text>
			</v-chip>
		</v-layout>

		<v-row class="mt-13">
			<v-col md="7">
				<PDFViewer />
			</v-col>
			<v-col md="5">
				<div v-if="isEmailSent" class="">
					<v-toolbar rounded class="base-shadow">
						<v-img
							contain
							width="24"
							alt="Brand Logo"
							class="shrink mr-2"
							src="@/assets/logo.svg"
						/>
						<base-text bold color="272">score</base-text>

						<v-layout class="space-x-4 ml-5">
							<selectable-chip active color="green">
								(60)
							</selectable-chip>
							<selectable-chip active color="yellow">
								(20)
							</selectable-chip>
							<selectable-chip active color="red">
								(10)
							</selectable-chip>
						</v-layout>

						<v-spacer />

						<v-layout justify-end class="space-x-2">
							<base-btn>
								<v-icon>mdi-check</v-icon>
								<span>Approve</span>
							</base-btn>

							<base-btn secondary>
								<v-icon>mdi-flag-outline</v-icon>
								<span>Flag</span>
							</base-btn>

							<base-btn secondary>
								<v-icon>mdi-download</v-icon>
								<span>CSV</span>
							</base-btn>
						</v-layout>
					</v-toolbar>
					<v-tabs
						v-model="currentTeam"
						hide-slider
						class="mt-4 >*:bg-transp email-view__team-tabs"
					>
						<v-tab v-for="team in teams" :key="team.id" :value="team.id">
							<base-text h2 tag="span" color="068">
								{{ team.text }}
							</base-text>
						</v-tab>
					</v-tabs>
					<v-card class="elevation-1">
						<v-card-text class="pa-8">
							<v-layout align-center class="space-x-2">
								<base-text h2 color="272">PO Related Data</base-text>

								<v-dialog
									v-model="dialogModifyDocument"
									max-width="748"
									class="z-9999"
									content-class="rounded-base"
								>
									<template #activator="{ on, attrs }">
										<base-btn v-on="on" v-bind="attrs" icon>
											<v-icon>mdi-plus</v-icon>
										</base-btn>
									</template>

									<v-card>
										<v-toolbar class="base-shadow">
											<v-toolbar-title>
												<base-text color="0f3" h2>
													Quick actions: Modify document
													classification
												</base-text>
											</v-toolbar-title>
											<v-spacer />
											<v-btn
												icon
												@click="dialogModifyDocument = false"
											>
												<v-icon size="30" color="#0F395D">
													mdi-close
												</v-icon>
											</v-btn>
										</v-toolbar>
										<v-card-text class="mt-7">
											<v-row>
												<v-col cols="2">
													<v-card
														flat
														outlined
														width="75"
														height="98"
														class="mx-auto d-flex align-center justify-center"
													>
														<base-text tiny bold color="707">
															1-150
														</base-text>
													</v-card>
												</v-col>
												<v-col cols="5">
													<div>
														<base-text color="272">
															Enter a page or page range
														</base-text>
														<v-text-field
															:value="'1-150'"
															dense
															outlined
															clearable
															hide-details
															class="base-input mt-2"
														/>
													</div>
												</v-col>
												<v-col cols="5">
													<div>
														<base-text color="272">
															Document type
														</base-text>
														<v-select
															:value="'POD'"
															:items="['POD']"
															dense
															outlined
															clearable
															hide-details
															class="base-input mt-2"
														>
															<template #selection="{ item }">
																<base-text
																	normal
																	tag="span"
																	color="272"
																>
																	{{ item }}
																</base-text>
															</template>
														</v-select>
													</div>
												</v-col>
											</v-row>
										</v-card-text>
										<v-card-actions class="px-6 pb-8">
											<base-btn>
												<span>Apply Changes</span>
											</base-btn>
											<base-btn
												secondary
												@click="dialogModifyDocument = false"
											>
												<span>Cancel</span>
											</base-btn>
										</v-card-actions>
									</v-card>
								</v-dialog>
							</v-layout>
							<v-simple-table class="email-view__table mt-3 base-shadow">
								<thead>
									<tr>
										<th>
											<base-text class="uppercase" color="068">
												Attribute
											</base-text>
										</th>
										<th>
											<base-text class="uppercase" color="068"
												>Value</base-text
											>
										</th>
										<th width="8rem">
											<v-img
												alt="Brand Logo"
												class="shrink mr-2"
												contain
												src="@/assets/logo.svg"
												transition="scale-transition"
												width="32"
											/>
										</th>
										<th width="8rem"></th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>
											<base-text color="272"> Customer </base-text>
										</td>
										<td>
											<base-text color="272">
												VLM FOODS USA LTD
											</base-text>
										</td>
										<td>
											<v-sheet
												width="20"
												height="20"
												class="bg-088 rounded-full"
											/>
										</td>
										<td>
											<v-btn icon>
												<v-icon>mdi-delete-outline</v-icon></v-btn
											>
										</td>
									</tr>
									<tr>
										<td>
											<base-text color="272"
												>Container Number</base-text
											>
										</td>
										<td>
											<base-text color="272">None</base-text>
										</td>
										<td>
											<v-sheet
												width="20"
												height="20"
												class="bg-ddd rounded-full"
											/>
										</td>
										<td>
											<v-btn icon>
												<v-icon>mdi-delete-outline</v-icon></v-btn
											>
										</td>
									</tr>
								</tbody>
							</v-simple-table>
						</v-card-text>
					</v-card>
				</div>

				<v-card v-else class="base-shadow" height="100%">
					<v-card-text>
						<base-text h2 color="068">
							<v-icon class="text-068" size="28">mdi-reply</v-icon>
							<span class="ml-2">Reply to Email</span>
						</base-text>

						<div class="mt-7">
							<base-text color="b7b">To</base-text>
							<v-text-field
								dense
								outlined
								clearable
								hide-details
								class="base-input"
							/>
						</div>

						<div class="mt-6">
							<base-text color="b7b">Subject</base-text>
							<v-text-field
								dense
								outlined
								clearable
								hide-details
								class="base-input"
							/>
						</div>

						<div class="mt-6">
							<base-text color="b7b">Message</base-text>
							<v-textarea
								:rows="12"
								dense
								outlined
								clearable
								hide-details
								class="base-input"
								placeholder="Write message here…"
							/>
						</div>
					</v-card-text>
					<v-card-actions>
						<v-spacer />
						<base-btn @click="isEmailSent = true">
							<v-icon>mdi-send</v-icon>
							<span>Send</span>
						</base-btn>
						<base-btn secondary>
							<span>Cancel</span>
						</base-btn>
					</v-card-actions>
				</v-card>
			</v-col>
		</v-row>

		<div :style="{ marginLeft: '208px' }">
			<base-text h2 color="707" class="mt-10">Comments</base-text>
			<v-card class="mt-3">
				<v-card-text class="pa-11">
					<v-layout class="space-x-5">
						<v-flex shrink>
							<v-avatar size="39" color="accent">
								<span class="white--text text-h6">VP</span>
							</v-avatar>
						</v-flex>
						<v-flex>
							<v-text-field
								dense
								outlined
								clearable
								hide-details
								class="base-input"
								placeholder="Add a comment…"
							/>
							<base-btn class="mt-4">
								<span>Submit</span>
							</base-btn>
						</v-flex>
					</v-layout>

					<v-divider class="my-6" />

					<v-layout class="space-x-5">
						<v-flex shrink>
							<v-avatar size="39" color="primary">
								<span class="white--text text-h6">JD</span>
							</v-avatar>
						</v-flex>
						<v-flex>
							<base-text bold color="707">
								Jane Doe |
								<base-text tag="span" color="707">
									August 15, 2022 at 12:30 pm
								</base-text>
							</base-text>
							<base-text color="707" class="mt-2">
								Supplier mentioned a delay with the shipment.
								<base-text tag="span" color="707" bold>
									@VictoriaPacitto
								</base-text>
								let’s get on a call to discuss solutions.
							</base-text>
						</v-flex>
					</v-layout>

					<v-divider class="my-6" />

					<v-layout class="space-x-5">
						<v-flex shrink>
							<v-avatar size="39" color="primary">
								<span class="white--text text-h6">VP</span>
							</v-avatar>
						</v-flex>
						<v-flex>
							<base-text bold color="707">
								Victoria Pacitto |
								<base-text tag="span" color="707">
									August 15, 2022 at 12:30 pm
								</base-text>
							</base-text>
							<base-text color="707" class="mt-2">
								<base-text tag="span" color="707" bold>
									@JaneDoe
								</base-text>
								were you able to contact the supplier? Give me an update
								as soon as you do.
							</base-text>
							<div class="mt-2">
								<base-text link color="707" tag="span">
									Edit
								</base-text>
								<base-text link color="707" tag="span" class="ml-4">
									Delete
								</base-text>
							</div>
						</v-flex>
					</v-layout>
				</v-card-text>
			</v-card>
		</div>
	</v-container>
</template>

<script>
import PDFViewer from '../components/PDFViewer.vue'
export default {
	name: 'EmailView',
	components: { PDFViewer },
	data: () => ({
		currentTeam: 0,
		isEmailSent: true,
		dialogModifyDocument: false,
		teams: [
			{
				id: 1,
				text: 'Headers',
			},
			{
				id: 2,
				text: 'Invoice',
			},
			{
				id: 3,
				text: 'Tables',
			},
		],
	}),
	computed: {
		breadcrumbs() {
			return [
				{
					href: '/inbox',
					disabled: false,
					text: 'Smart Inbox',
				},
				{
					disabled: true,
					text: this.$route.params.id,
					href: `inbox/${this.$route.params.id}`,
				},
			]
		},
	},
}
</script>

<style lang="scss">
.email-view {
	&__team {
		&-tabs {
			.v-tab {
				padding: 1.25rem 2rem !important;
				&--active {
					position: relative;
					background-color: white;
					box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%),
						0px 1px 1px 0px rgb(0 0 0 / 14%),
						0px 1px 3px 0px rgb(0 0 0 / 12%) !important;
					&::after {
						content: '';
						bottom: 0;
						left: 50%;
						width: 75%;
						height: 2px;
						position: absolute;
						transform: translateX(-50%);
						background-color: black;
					}
				}
			}
		}
	}
	&__table {
		th {
			background-color: #f0f0f0;
		}
	}
}
</style>
